import { render, staticRenderFns } from "./CourseLeadersListTab.vue?vue&type=template&id=758b198c&lang=pug&"
import script from "./CourseLeadersListTab.vue?vue&type=script&lang=js&"
export * from "./CourseLeadersListTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports